import { render, staticRenderFns } from "./WechatLogin.vue?vue&type=template&id=4ac6f1ba&scoped=true&"
import script from "./WechatLogin.vue?vue&type=script&lang=js&"
export * from "./WechatLogin.vue?vue&type=script&lang=js&"
import style0 from "./WechatLogin.vue?vue&type=style&index=0&id=4ac6f1ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac6f1ba",
  null
  
)

export default component.exports